import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Maestro_Productos } from '../models/generic/Maestro_Productos';

@Injectable({
  providedIn: 'root'
})
export class Maestros_ProductosService {
  
  ListaProductos: Maestro_Productos[] = [];
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  ConsultarAliados(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CONSULTAR_ALIADOS()}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  ConsultarListas(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CONSULTAR_LISTAS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Consultar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Actualizar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_ACTUALIZAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarPlazos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_PLAZOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarEdades(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_EDADES_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarExpedientes(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_EXPEDIENTES_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarEstadosDias(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_ESTADOSDIAS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarFirmaElectronica(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_FIRMAELECTRONICA_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarCodigosActivacion(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CODIGOSACTIVACION_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarCodigosCargar(parametros: any, idAliado: number, idProducto: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CODIGOSACTIVACION_CARGAR()}/${idAliado}/${idProducto}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  SubirArchivoFirmaElectronica(parametros: any, idAliado: number, idProducto: number, idProductoFirma: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_SUBIRARCHIVOFIRMAELECTRONICA()}/${idAliado}/${idProducto}/${idProductoFirma}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  DescargarArchivoFirmaElectronica(parametros: any, idAliado: number, idProducto: number, idProductoFirma: number): any {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_DESCARGARARCHIVOFIRMAELECTRONICA()}/${idAliado}/${idProducto}/${idProductoFirma}`;
    return this.comunicacionapiService.PostDescarga(urlServicio, parametros);
  }
  ConsultarCampos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CAMPOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarCamposBeneficiarios(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_CAMPOSBENEFICIARIOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarNotificaciones(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.MAESTROS_PRODUCTOS_NOTIFICACIONES_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
